export default "__VITE_ASSET__DoVYKfw5__"